<template>
<li class="Phase" :class="{'Phase--optional': itemValues.optional, 'Phase--noTime': !itemValues.time}">
	<span class="Phase-Name">{{itemValues.name}}</span>
    <span class="Phase-Price">
		<span>{{itemValues['Price-Long']}}</span>
        <div v-if="itemValues.taxes !== undefined">zzgl. {{itemValues.taxes}}% Ust.</div>
		<div v-else-if="itemValues['Taxes-19']">zzgl. 19% USt.</div>
		<div v-else>zzgl. 7% USt.</div>
	</span>
	<span class="Phase-Time" v-if="!!itemValues['time']">{{itemValues['Time-Long']}}</span>

	<ul>
		<slot>

		</slot>
	</ul>

</li>
</template>

<script>
export default {
	name: 'MilestonePhase',
	props: {
		itemValues: {
			type: Object,
			default () {
				return {
					name: "",
					time: "",
					price: "",
					timeInDays: false,
					'Price-Long': "",
					'Time-Long': "",
				}
			}
		},
        milestones: {
            type: Object,
            default(){
                return {};
            }
        },
	},
	components: {},
	data() {
		return {}
	},
	created() {},
	watch: {},
	computed: {

	},

	methods: {

	},

	mounted() {}
}
</script>

<style lang="scss">
.Phase {
    position: relative;
    grid-column: span 3;
    display: grid;
    grid-template-columns: subgrid;
    row-gap: 5px;
    padding-left: 5px;
    font-size: 9.5pt;

    &--noTime {
        grid-column: 1 / 3;
    }

    &::after {
        content: "";
        position: absolute;
        width: 7px;
        height: 7px;
        left: -4px;
        top: 6px;
        background: white;
        border-radius: 100%;
        border: solid 0.5px color(text-negative);
    }

    span {
        display: block;
    }

    &-Name,
    &-Price,
    &-Time {
        min-height: 10px;
        line-height: 1.5;
    }

    &-Name {
        font-size: 10pt;
        font-weight: 700;
        margin-left: 15px;
        padding-right: 15px;
    }

    &-Price {
        text-align: right;
        margin-bottom: -8pt;

        > div {
            font-size: 8pt;
            padding-top: 8px;
        }
    }

    &-Time {
        text-align: right;
    }

    &.Linebreak--SubItem {
        > li:first-child {
            &::after {
                display: none;
            }
        }
    }

    &--optional {
        padding: 0;

        &::after {
            display: none;
        }

        & > span {
            &:first-child {
                margin-left: 0;
            }
        }
    }

    &--noName {
        & > span {
            display: none;
        }

        &::after {
            display: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// Phase.vue?c87244fa